import { Fragment, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { obtenerBalance, limpiarBalance } from '../../../actions/pagosVentas';

const formatMoney = (n) => {
    const v = Number(n || 0);
    return `$${new Intl.NumberFormat('en-US', { minimumFractionDigits: 3, maximumFractionDigits: 3 }).format(v)}`;
};

const StatCard = ({ label, value, tone }) => (
    <div className="col-md-4 col-6 mb-3">
        <div className="border rounded p-3 h-100">
            <div className="text-muted small">{label}</div>
            <div className={`fs-5 fw-bold${tone ? ` text-${tone}` : ''}`}>{value}</div>
        </div>
    </div>
);

const ResumenCliente = ({ idCliente }) => {
    const dispatch = useDispatch();

    const { resumen, loadingBalance } = useSelector(state => state.pagosVentas);

    useEffect(() => {
        if (!idCliente) return;

        dispatch(obtenerBalance(idCliente));

        return () => {
            dispatch(limpiarBalance());
        };
    }, [dispatch, idCliente]);

    if (loadingBalance && !resumen) {
        return (
            <div className="text-muted py-4">Cargando resumen...</div>
        );
    }

    const saldoPendiente = Number(resumen?.saldo_pendiente || 0);

    return (
        <Fragment>
            <div className="text-muted mb-2" style={{ fontSize: 12 }}>
                Los totales se expresan en su equivalente en MXN (las ventas y pagos en USD se convierten con su propio tipo de cambio).
            </div>
            <div className="row">
                <StatCard label="Total en ventas (MXN)" value={formatMoney(resumen?.total_deuda)} />
                <StatCard label="Total pagado (MXN)" value={formatMoney(resumen?.total_pagado)} tone="success" />
                <StatCard
                    label="Saldo pendiente (MXN)"
                    value={formatMoney(saldoPendiente)}
                    tone={saldoPendiente > 0 ? 'warning' : 'success'}
                />
            </div>
        </Fragment>
    );
};

export default ResumenCliente;
